import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const AdminRoute = ({ component: Component, authenticated, userCredentials, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      // If not authenticated, redirect to login
      if (!authenticated) {
        return <Redirect to="/login" />;
      }
      
      // If user data is not loaded yet, show loading or wait
      if (!userCredentials || Object.keys(userCredentials).length === 0) {
        return (
          <div style={{ 
            padding: '20px', 
            textAlign: 'center', 
            color: 'gold',
            backgroundColor: 'black',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <div style={{ fontSize: '18px' }}>Loading...</div>
          </div>
        );
      }
      
      // Check if user has admin role
      if (!('role' in userCredentials) || userCredentials.role !== 'Admin') {
        return <Redirect to="/" />;
      }
      
      // User is authenticated and has admin role
      return <Component {...props} />;
    }}
  />
);

const mapStateToProps = (state) => ({
  authenticated: state.user.authenticated,
  userCredentials: state.user.credentials
});

AdminRoute.propTypes = {
  authenticated: PropTypes.bool,
  userCredentials: PropTypes.object
};

export default connect(mapStateToProps)(AdminRoute);